import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Alignment, Button, Checkbox, Classes, InputGroup, Intent, Popover, PopoverPosition, Switch, Tooltip, } from '@blueprintjs/core';
import { mdiCheckboxMarkedOutline, mdiCloseCircle, mdiFilterRemove, mdiMenuDown, mdiOpenInApp } from '@mdi/js';
import { Component } from 'react';
import ReactList from 'react-list';
import IKon from './IKon';
const defaultMultiSelectDropDownState = {
    opened: false,
    filter: null,
    selectedOnly: false,
    filtered: [],
    selected: [],
};
export class MultiSelectDropDown extends Component {
    constructor() {
        super(...arguments);
        this.state = defaultMultiSelectDropDownState;
        this.renderItem = (item, key, index) => {
            const { labelField, iconRenderer, itemClassName, allowSingle, minimumSelection } = this.props;
            const { filtered, selected } = this.state;
            return (_jsxs("div", Object.assign({ className: 'multi-select-line' }, { children: [_jsxs(Checkbox, Object.assign({ checked: selected.indexOf(item) >= 0, onChange: _ => this.handleCheckboxChange(item, _.currentTarget.checked), className: `multi-select-checkbox ${itemClassName
                            ? typeof itemClassName == 'function'
                                ? itemClassName(item, index)
                                : itemClassName
                            : ''}` }, { children: [iconRenderer ? iconRenderer(item) : null, _jsx("span", Object.assign({ className: 'label' }, { children: item[labelField] }), void 0)] }), key), !!allowSingle && (minimumSelection || 0) <= 1 && (_jsx(Button, { className: 'single-select', icon: _jsx(IKon, { icon: mdiCheckboxMarkedOutline, size: 14 }, void 0), onClick: () => this.submitSelected([item]) }, void 0))] }), key));
        };
        this.render = () => {
            var _a, _b, _c;
            const { compact, source, buttonLabel, buttonIcon, labelField, showFilter, showCount, showCheckAll, buttonClassName, minimumSelection, } = this.props;
            const { filter, filtered, opened, selected, selectedOnly } = this.state;
            const displayFiltered = selectedOnly ? filtered.filter(o => selected.indexOf(o) >= 0) : filtered;
            return (_jsxs(Popover, Object.assign({ minimal: true, isOpen: opened, onClose: () => this.handlePopoverClose(), position: PopoverPosition.BOTTOM_LEFT }, { children: [_jsx(Tooltip, Object.assign({ popoverClassName: `multi-dropdown-tooltip ${Classes.MINIMAL}`, disabled: !((_a = this.props.selected) === null || _a === void 0 ? void 0 : _a.length) && !compact, content: ((_b = this.props.selected) === null || _b === void 0 ? void 0 : _b.map(o => o[labelField]).join(', ')) || this.props.buttonLabel, lazy: true, openOnTargetFocus: false }, { children: _jsx(Button, Object.assign({ small: compact, className: `multi-dropdown-button ${!compact && buttonClassName ? buttonClassName : ''}`, alignText: Alignment.LEFT, icon: buttonIcon ? buttonIcon : null, rightIcon: compact ? _jsx(IKon, { icon: mdiMenuDown, size: 16 }, void 0) : null, onClick: () => this.handleOpenButtonClick() }, { children: showCount && ((_c = this.props.selected) === null || _c === void 0 ? void 0 : _c.length)
                                ? compact
                                    ? this.props.selected.length
                                    : `${buttonLabel} (${this.props.selected.length})`
                                : compact
                                    ? null
                                    : `${buttonLabel}` }), void 0) }), void 0), _jsxs("div", Object.assign({ className: 'multi-dropdown-content' }, { children: [showFilter ? (_jsx("div", Object.assign({ className: 'multi-dropdown-header' }, { children: _jsx(InputGroup, { value: filter ? filter : '', placeholder: 'Filtrer', className: 'multi-dropdown-filter-input', onChange: (event) => this.handleFilterInputChange(event.currentTarget.value), rightElement: _jsx(Button, { minimal: true, icon: _jsx(IKon, { icon: mdiCloseCircle, size: 16 }, void 0), disabled: !(filter === null || filter === void 0 ? void 0 : filter.length), onClick: () => this.setState({ filter: null, filtered: [...source] }) }, void 0) }, void 0) }), void 0)) : null, _jsx("div", Object.assign({ className: 'multi-dropdown-list' }, { children: _jsx(ReactList, { itemRenderer: (index, key) => this.renderItem(displayFiltered[index], key, index), length: displayFiltered.length, type: 'uniform' }, void 0) }), void 0), showCheckAll ? (_jsx("div", Object.assign({ className: 'multi-dropdown-check-all-footer' }, { children: _jsxs(_Fragment, { children: [_jsx(Checkbox, { indeterminate: !!selected.length && selected.length < source.length, checked: selected.length == source.length, label: 'Tous s\u00E9lectionner', onChange: _ => this.handleCheckAllChange(_.currentTarget.checked) }, void 0), _jsx("div", { className: 'spacer' }, void 0), !showFilter ? (_jsxs(_Fragment, { children: [!minimumSelection ? (_jsx(Button, { small: true, minimal: true, icon: _jsx(IKon, { icon: mdiFilterRemove, size: 12 }, void 0), onClick: () => this.handleClearFilterButtonClick() }, void 0)) : null, _jsx(Button, { intent: Intent.PRIMARY, disabled: selected.length < (minimumSelection || 0), icon: _jsx(IKon, { icon: mdiOpenInApp, size: 20 }, void 0), onClick: () => this.handleFilterButtonClick() }, void 0)] }, void 0)) : null] }, void 0) }), void 0)) : null, showFilter ? (_jsx("div", Object.assign({ className: 'multi-dropdown-filter-footer' }, { children: _jsxs(_Fragment, { children: [_jsx(Switch, { disabled: !(selected === null || selected === void 0 ? void 0 : selected.length), label: (selected === null || selected === void 0 ? void 0 : selected.length) ? `Sélectionnés (${selected === null || selected === void 0 ? void 0 : selected.length})` : 'Sélectionnés', onChange: _ => this.handleSelectedOnlyChange(_.currentTarget.checked) }, void 0), _jsx("div", { className: 'spacer' }, void 0), !minimumSelection ? (_jsx(Button, { small: true, minimal: true, icon: _jsx(IKon, { icon: mdiFilterRemove, size: 12 }, void 0), onClick: () => this.handleClearFilterButtonClick() }, void 0)) : null, _jsx(Button, { intent: Intent.PRIMARY, icon: _jsx(IKon, { icon: mdiOpenInApp, size: 20 }, void 0), disabled: selected.length < (minimumSelection || 0), onClick: () => this.handleFilterButtonClick() }, void 0)] }, void 0) }), void 0)) : null] }), void 0)] }), void 0));
        };
    }
    componentDidMount() {
        this.setState({ selected: this.props.selected ? this.props.selected : [] });
        this.createFilteredList();
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.source != this.props.source || prevState.filter != this.state.filter) {
            this.createFilteredList();
        }
        if (prevProps.selected != this.props.selected) {
            this.setState({ selected: this.props.selected ? this.props.selected : [] });
        }
    }
    createFilteredList() {
        const { filter, selected, selectedOnly } = this.state;
        const { source, labelField } = this.props;
        let filtered = filter
            ? source.filter(o => o[labelField].toLowerCase().includes(filter.toLowerCase()))
            : source;
        this.setState({ filtered });
    }
    handleFilterInputChange(filter) {
        const { source, labelField } = this.props;
        this.setState({
            filter: filter.length ? filter : null,
        });
    }
    handleCheckboxChange(o, b) {
        const selected = [...this.state.selected];
        if (b) {
            selected.push(o);
        }
        else {
            selected.splice(selected.indexOf(o), 1);
        }
        this.setState({ selected });
    }
    handleSelectedOnlyChange(selectedOnly) {
        this.setState({ selectedOnly });
    }
    handleFilterButtonClick() {
        this.submitSelected();
    }
    submitSelected(selected) {
        selected = selected ? selected : this.state.selected;
        const { onChange } = this.props;
        this.setState({ selected });
        if (onChange)
            onChange([...selected]);
        this.closePopover();
    }
    handlePopoverClose() {
        this.setState({ selectedOnly: false, selected: this.props.selected || [] });
        this.closePopover();
    }
    closePopover() {
        this.setState({ filter: null, opened: false });
    }
    handleOpenButtonClick() {
        this.setState({ opened: true });
    }
    handleClearFilterButtonClick() {
        this.submitSelected([]);
    }
    handleCheckAllChange(b) {
        const { source } = this.props;
        this.setState({ selected: b ? [...source] : [] });
    }
}
MultiSelectDropDown.defaultProps = { selected: [], showFilter: true, showCheckAll: false, showCount: true };
